import { PolicyFlowConference } from 'src/types'

export const initialValues = {} as PolicyFlowConference

export const defaultValue = {
  active: true,
  automatic_conference: false,
  code: '',
  consensual_conference: false,
  cost_center_conference: false,
  description: '',
  exception_checker: false,
  name: '',
  policy_conference_id: 'new',
  reason_conference: false
} as PolicyFlowConference
